import { printWithAgent } from './agent';
import { printWithEpos } from './eposPrint';
import { printWithBluetooth } from './webBluetooth';

export const PRINTER_TYPE_OPTIONS = [
  { value: 'network', label: 'Netzwerk (IP)', via: 'agent', hint: 'Bondrucker im LAN, z. B. 192.168.1.50:9100' },
  { value: 'system', label: 'System / USB-Warteschlange', via: 'agent', hint: 'Im Betriebssystem eingerichteter Drucker' },
  { value: 'serial', label: 'Bluetooth am Computer', via: 'agent', hint: 'Mit dem Computer gekoppelter Bluetooth-Drucker, z. B. /dev/cu.BLTH' },
  { value: 'epson_epos', label: 'Epson ePOS (ohne Agent)', via: 'browser', hint: 'Epson TM mit ePOS, druckt direkt aus dem Browser' },
  { value: 'bluetooth', label: 'Bluetooth mobil', via: 'browser', hint: 'Persönlicher BLE-Drucker (Chrome auf Android)' },
];

const AGENT_TYPES = new Set(['network', 'system', 'serial', 'usb']);

export function printerNeedsAgent(printer) {
  return AGENT_TYPES.has(String(printer?.type || '').toLowerCase());
}

export function printerTypeLabel(type) {
  if (type === 'usb') return 'USB (alt)';
  return PRINTER_TYPE_OPTIONS.find((option) => option.value === type)?.label || type || 'Unbekannt';
}

export function base64ToBytes(base64) {
  const binary = atob(base64 || '');
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}

// Executes one claimed print job ({printer, content_type, data_base64, title}) on this device.
export async function executePrintJob(job) {
  const printer = job?.printer;
  if (!printer) throw new Error('Der Drucker dieses Auftrags existiert nicht mehr');
  const target = String(printer.connection_string || '').trim();
  const contentType = job.content_type || 'escpos';

  switch (String(printer.type || '').toLowerCase()) {
    case 'network':
      return printWithAgent({ transport: 'tcp', target, contentType, dataBase64: job.data_base64, title: job.title });
    case 'system':
      return printWithAgent({ transport: 'system', target, contentType, dataBase64: job.data_base64, title: job.title });
    case 'serial':
      return printWithAgent({ transport: 'serial', target, contentType, dataBase64: job.data_base64, title: job.title });
    case 'epson_epos':
      if (contentType !== 'escpos') throw new Error('Epson ePOS unterstützt nur Bondrucker-Papierbreiten (58/80 mm)');
      return printWithEpos(target, base64ToBytes(job.data_base64));
    case 'bluetooth':
      if (contentType !== 'escpos') throw new Error('Bluetooth-Drucker unterstützen nur Bondrucker-Papierbreiten (58/80 mm)');
      return printWithBluetooth(target, base64ToBytes(job.data_base64));
    case 'usb':
      throw new Error('USB-Drucker bitte als „System / USB-Warteschlange“ neu einrichten');
    default:
      throw new Error(`Unbekannter Druckertyp: ${printer.type}`);
  }
}
